/*
 * Confidential and Trade Secret Information of Aila Technologies, Inc.
 * Copyright Aila Technologies, Inc. All Rights Reserved.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en'

const resources = {
  en,
}

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: import.meta.env.DEV,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lng: 'en',
    resources,
  })

i18n.services.formatter?.add('industry', (value, lng, options) => {
  return value === 'retail' ? 'account' : 'dealership'
})

export default i18n
